import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import StorefrontSection from 'marketplace-ui-common/storefront/components/StorefrontSection';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getFeaturedAppsUrl } from '../../utils/urls';
import AppCollectionsCardGrid from './AppCollectionsCardGrid';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AppCollectionsResultsSection({
  trackInteraction
}) {
  const {
    paddingBlockEnd
  } = useResponsiveProps({
    paddingBlockEnd: {
      sm: '1100',
      md: '0'
    }
  });
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    paddingBlockEnd: paddingBlockEnd,
    paddingBlockStart: "1000",
    paddingInline: "1100",
    children: /*#__PURE__*/_jsx(StorefrontSection, {
      primaryGridSize: 9,
      subtitle: /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "0",
        as: "p",
        children: /*#__PURE__*/_jsx(Big, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.storefront.results.collections.collectionsSubtitle"
          })
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.results.collections.collectionsTitle"
      }),
      titleControls: /*#__PURE__*/_jsx(UIRouterLink, {
        onClick: () => trackInteraction('click featured apps link'),
        to: getFeaturedAppsUrl(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.results.collections.collectionsLink"
        })
      }),
      titleControlsMobile: "md",
      children: /*#__PURE__*/_jsx(Section, {
        use: "island",
        children: /*#__PURE__*/_jsx(AppCollectionsCardGrid, {})
      })
    })
  });
}